import BoxListButton from "@components/BoxListButton";
import { MEDIA_DETAIL, MEDIA_MODIFY } from "@constants/routes";
import { timestampToString } from "@helpers/dates.format";
import { getCapitalizedFirstChar } from "@helpers/string";
import { ICreateMedia } from "@interfaces/createMedia";

const listMediaMapper = (items: ICreateMedia[], handleDelete: Function) =>
  items.map(({ uuid, title, date, type, createdAt }) => ({
    uuid,
    title,
    date: timestampToString(date),
    _dateTs: date ?? 0,
    type: getCapitalizedFirstChar(type),
    createDate: timestampToString(createdAt),
    _createDateTs: createdAt ?? 0,
    actions: (
      <BoxListButton
        uuid={uuid}
        description={title}
        detailRoute={MEDIA_DETAIL}
        modifyRoute={MEDIA_MODIFY}
        handleDelete={handleDelete}
      />
    ),
  }));

export default listMediaMapper;
